// Types
import {
  GetAthleteStreams_liveAndUpcomingStreams_entities,
  GetAthleteStreams_pastStreams_entities,
} from 'api/streams/types/GetAthleteStreams';
// Ui
import LinkButton from 'ui3/LinkButton/LinkButton';
// Components
import RelatedStreams from 'components/Athlete/Streams/RelatedStreams/RelatedStreams';
// Styles
import styles from './StreamUpcomingEvents.module.scss';

type StreamUpcomingEventsProps = {
  streams:
    | GetAthleteStreams_liveAndUpcomingStreams_entities[]
    | GetAthleteStreams_pastStreams_entities[];
  seeAllLink?: string;
};

const StreamUpcomingEvents = ({
  streams,
  seeAllLink,
}: StreamUpcomingEventsProps): JSX.Element | null => {
  if (streams.length === 0) {
    return null;
  }

  return (
    <section
      className={styles.root}
      aria-labelledby="stream-upcoming-events-heading"
    >
      <header className={styles.header}>
        <div className={styles.headerText}>
          <h2 id="stream-upcoming-events-heading" className={styles.title}>
            Upcoming Events
          </h2>
          <p className={styles.subtitle}>
            Don&apos;t miss what&apos;s coming next.
          </p>
        </div>

        {seeAllLink && (
          <LinkButton
            variant="secondary"
            link={seeAllLink}
            iconPosition="right"
            iconSize={22}
          >
            See Channel
          </LinkButton>
        )}
      </header>

      <RelatedStreams streams={streams} padding="none" />
    </section>
  );
};

export default StreamUpcomingEvents;
